<template>
  <component
    :is="hasLink ? 'a' : 'button'"
    :class="$b('level-3-heading', {
      hasLink
    })"
    :href="hasLink ? link : null"
    @click="handleClick($event)"
  >
    {{ navItem.buttonText }}
  </component>
</template>
<script>
export default {
  name: 'MainNavButtonCard',
}
</script>
<script setup>
const { isMdBreakpointOrAbove } = useBreakpoint()

const props = defineProps({
  index: {type: Number, required: true},
  hasLink: {type:Boolean, required:false, default: false},
  link: {type: String, required: false, default: null},
  navItem: {type: Object, required: true}
})
const emits = defineEmits(['toggleLevel3Menu'])

function handleClick(event) {
  if (!isMdBreakpointOrAbove.value) {
    event.preventDefault();
    emits('toggleLevel3Menu', props.index)
  }
}
</script>

<style lang="postcss">
.MainNavButtonCard {
  @apply w-full lg:w-auto;
}

.MainNavButtonCard__level-3-heading {
  @apply text-left lgMax:block lgMax:w-full lg:cursor-default;

  @screen lgMax {
    @apply w-full relative;

    &::before,
    &::after {
      @apply content-[''] absolute right-0 top-3
      w-5 h-0.5 rounded-full bg-off-black opacity-0
      pointer-events-none
      transition-all duration-500;
    }

    &::before {
      @apply rotate-90;
    }
  }

  @screen lg {
    &--has-link {
      @apply relative cursor-pointer;

      &::before {
        @apply content-[''] absolute w-full h-[1px] -bottom-1
        bg-off-black
        scale-x-0 origin-right transition-transform duration-300;
      }
    }

    &:hover::before {
      @apply scale-x-100 origin-left;
    }
  }
}

.MainNav__level-2-item:has(.MainNav__level-3-links--open) {
  .MainNavButtonCard__level-3-heading::before {
    @apply rotate-0;
  }
}
</style>